import {inject, Injectable} from "@angular/core";
import {
    ActionService,
    ConfigurationService,
    EntityData,
    field,
    JwtHttpClientService,
    ResourceModule
} from "@fedelta-pos/data-client";

export class InvoiceEmailRequestData extends EntityData<InvoiceEmailRequestData> {
    @field customerRefNo: string;
    @field email: string;
}

@Injectable()
export class InvoiceEmailRequestService extends ActionService {
    constructor() {
        const http: JwtHttpClientService = inject(JwtHttpClientService);
        const configService: ConfigurationService = inject(ConfigurationService);
        const nameSpace: string = inject<string>(ResourceModule.RESOURCE_NAMESPACE_KEY);
        const actionNames: string[] = inject<string[]>(ResourceModule.ACTION_NAMES_KEY);
        const useAsync: boolean = inject<boolean>(ResourceModule.RESOURCE_USE_ASYNC);

        console.log("--- InvoiceEmailRequestService");

        super(http, nameSpace, "invoice-email-request", configService, useAsync, actionNames);
    }
}
